import "bootstrap-sass";

import React from "react";
import ReactDOM from "react-dom";

import initBrochureRequestForms from "../components/brochure";
import initMastersExperienceEnquiry from "../components/enquiries/masters_experience_enquiry";
import PackageGenerator from "../components/static_pages/PackageGenerator";
import initEmarsysForm from "../utils/Emarsys";

import carouselise from "../scripts/sections/image-carousel";
import lazyLoadMap from "../shared/helpers/map_loader";
import UserTiming from "../shared/helpers/user-timing";

// from common.js
import autocompleteToggle from "../components/autocomplete/AutocompleteToggle.js";
import embedYoutube from "../components/video.js";
import initGeneralEnquiry from "../components/enquiries/general_enquiry";
import initNamedEnquiry from "../components/enquiries/named_enquiry";
import scrollspy from "../components/scrollspy/scrollspy.js";

import mountNewsletterForm from "../controllers/Newsletter.jsx";
import mountPopovers from "../controllers/Popover.jsx";

import notifier from "../shared/helpers/airbrake";
import ellipsis from "../shared/helpers/ellipsis";
import emarsys from "../shared/helpers/emarsys";
import { trackClick } from "../shared/helpers/gtm_tracking";

import "../shared/helpers/defer-picture";
import "../shared/helpers/responsive-bg";
import '../shared/gtm-script-loader';

import "./common.scss";
// end from common.js

import "../scripts/sections/blocks/autocomplete";

import "./dynamic_page.scss";

const userTiming = new UserTiming({ src: "staticPages" });

// from common.js
function handleClickTracking() {
  document.addEventListener("click", e => {
    const target = e.target.closest(".gtm-track-click");

    if (target) {
      trackClick(target);
    }
  });
}
// end from common.js

const renderPackages = () => {
  document.querySelectorAll(".package-box").forEach(node => {
    ReactDOM.render(
      <PackageGenerator
        packageId={node.dataset.packageId}
        slug={node.dataset.slug}
      />,
      node
    );
  });
};

function onDOMContentLoaded() {
  userTiming.start("onDOMContentLoaded");

  userTiming.start("common");
  // from common.js
  autocompleteToggle();
  initGeneralEnquiry();
  initNamedEnquiry();
  handleClickTracking();
  ellipsis();
  embedYoutube();
  mountNewsletterForm();
  mountPopovers();
  scrollspy();

  // end from common.js
  userTiming.finish("common");

  renderPackages();
  initMastersExperienceEnquiry();
  initBrochureRequestForms();
  lazyLoadMap();
  initEmarsysForm();
  carouselise();

  userTiming.finish("onDOMContentLoaded");
}

document.addEventListener("DOMContentLoaded", onDOMContentLoaded);

// from common.js
window.addEventListener("error", error => {
  notifier.notify({ error });
});

emarsys(window.emarsysData);
// end from common.js

userTiming.finish();



// WEBPACK FOOTER //
// ./entry_points/tournament.jsx